export default function Burger(props) {
    const toggleMenu = () => {
        props.toggle();
    };

    return (
        <div className={`hamburger ${props.isOpen ? 'open' : ''}`} onClick={toggleMenu}>
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
        </div>
        )
}